

















import Vue from 'vue';
import { Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import * as types from '@/store/types';
import {
    ISiteManualDetailModel,
    getListItemHeading,
    IListItem,
    IModelWithLoading
} from '@/entities';
import { mapGetters } from 'vuex';

@Component({
    computed: mapGetters({
        siteManuals: types.APIDATA_GET_SITEMANUALS
    })
})
export default class SiteManualsView extends Vue {
    public siteManuals: IModelWithLoading<ISiteManualDetailModel[]>;
    public activeTabId: number = null;

    get rawHtml(): string {

        if (!this.siteManuals.model || !this.activeTabId) {
            return '';
        }

        const items = this.siteManuals.model;
        for (let item of items) {
            if (item.id === this.activeTabId) {
                return item.html;
            }
        }

        return '';
    }

    get tabs(): IListItem[] {
        if (!this.siteManuals.model) {
            return [];
        }
        return this.siteManuals.model.map((x) => {
            return { heading: x.title, value: x.id };
        });
    }

    get loading() {
        return this.siteManuals.loading;
    }

    get currentTitle() {
        return getListItemHeading(this.tabs, this.activeTabId);
    }

    public async created() {
        this.$store.dispatch(types.APIDATA_SITEMANUALS_ENTER);
    }

    public async changeTab(newId) {
        this.activeTabId = newId;
    }

    @Watch('tabs')
    private onTabsChanged(val: string) {
        if (this.activeTabId === null && this.tabs.length) {
            this.changeTab(this.tabs[0].value);
        }
    }


}
